/* ============================================================
   MC HEADER — scroll state, mobile drawer, sticky menu button
   Vanilla JS, no dependencies. Mirrors the reference script.js
   (initHeader / initMobileNav / initStickyMenu).
   ============================================================ */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- 1. Header scroll state (border on scroll, hide on scroll-down) ---- */
  function initHeaderScroll() {
    var header = document.querySelector('[data-mc-header]');
    if (!header) return;
    var lastScroll = 0;
    var ticking = false;

    function update() {
      var y = window.scrollY;
      if (y > 40) header.classList.add('is-scrolled');
      else header.classList.remove('is-scrolled');

      if (!reduceMotion && y > 600) {
        if (y > lastScroll && y - lastScroll > 10) {
          header.classList.add('is-hidden');
        } else if (lastScroll - y > 10) {
          header.classList.remove('is-hidden');
        }
      } else {
        header.classList.remove('is-hidden');
      }
      lastScroll = y;
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });
    update();
  }

  /* ---- 2. Mobile nav drawer ---- */
  function initMobileNav() {
    var drawer = document.querySelector('[data-mc-nav-drawer]');
    var overlay = document.querySelector('[data-mc-nav-overlay]');
    var toggles = document.querySelectorAll('[data-mc-nav-toggle]');
    var closers = document.querySelectorAll('[data-mc-nav-close]');
    if (!drawer || !toggles.length) return;

    var lastFocus = null;

    function setExpanded(state) {
      for (var i = 0; i < toggles.length; i++) {
        toggles[i].setAttribute('aria-expanded', state ? 'true' : 'false');
      }
    }

    function open() {
      lastFocus = document.activeElement;
      drawer.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      // Take the drawer OUT of inert so its contents become keyboard-focusable.
      drawer.removeAttribute('inert');
      document.body.style.overflow = 'hidden';
      setExpanded(true);
      var focusable = drawer.querySelector('a[href], button:not([disabled])');
      if (focusable) focusable.focus();
    }

    function close() {
      drawer.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      setExpanded(false);
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
      // Make the closed (off-screen) drawer inert so keyboard focus can't land
      // inside it — otherwise Tab disappears into the hidden panel.
      drawer.setAttribute('inert', '');
    }

    for (var i = 0; i < toggles.length; i++) {
      toggles[i].addEventListener('click', function (e) { e.preventDefault(); open(); });
    }
    for (var j = 0; j < closers.length; j++) {
      closers[j].addEventListener('click', close);
    }
    if (overlay) overlay.addEventListener('click', close);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });

    drawer.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var nodes = drawer.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])');
      if (!nodes.length) return;
      var first = nodes[0];
      var last = nodes[nodes.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  /* ---- 3. Sticky menu button — appears after scrolling past the hero ---- */
  function initStickyMenu() {
    var btn = document.querySelector('[data-mc-sticky-menu]');
    if (!btn) return;

    function threshold() {
      var hero = document.querySelector('[data-mc-hero], .hero, .mc-hero');
      var h = hero ? hero.offsetHeight : window.innerHeight;
      return Math.max(120, h - 80);
    }
    function update() {
      if (window.scrollY > threshold()) btn.classList.add('is-visible');
      else btn.classList.remove('is-visible');
    }
    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
  }

  /* ---- 4. Overlay header — offset below the announcement bar (no hardcoded height) ---- */
  function initOverlayOffset() {
    var header = document.querySelector('[data-mc-header][data-mc-overlay]');
    if (!header) return; // only when the overlay toggle is on (home page)

    function update() {
      var ann = document.querySelector('.mc-announcement');
      var top = (ann ? ann.offsetHeight : 0) + 'px';
      // Publish on :root so other sections (e.g. mc-hero-banner) can size to the
      // space below the announcement bar; the overlay header inherits it too.
      document.documentElement.style.setProperty('--mc-header-top', top);
    }

    update();
    window.addEventListener('resize', update);
    window.addEventListener('load', update);
    document.addEventListener('shopify:section:load', update);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(update);
    }
  }

  function init() {
    initHeaderScroll();
    initMobileNav();
    initStickyMenu();
    initOverlayOffset();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
